import React, { useEffect, useState } from "react";
import axios from "axios";

const PicoftheDay = () => {
    const [randomImage, setRandomImage] = useState(null);

    useEffect(() => {
        const fetchRandomImage = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/images/?is_public=true`);
                const images = res.data.results || res.data || [];
                if (images.length > 0) {
                    const randomIndex = Math.floor(Math.random() * images.length);
                    setRandomImage(images[randomIndex]);
                } else {
                    setRandomImage(null);
                }
            } catch (error) {
                console.error("Fehler beim Abrufen des Zufallsbildes:", error);
                setRandomImage(null);
            }
        };

        fetchRandomImage();
    }, []);

    if (!randomImage) return null;

    return (
        <div>
            <div style={{
                display: "flex",
                alignItems: "center",
                minHeight: 56,
                marginBottom: 24
            }}>
                <h3 style={{
                    fontFamily: "'Merriweather', serif",
                    fontSize: 24,
                    color: "#5cb1ce",
                    margin: 0,
                    lineHeight: "56px"
                }}>
                    Foto des Tages
                </h3>
            </div>
            <figure
                style={{
                    margin: 0,
                    borderRadius: 16,
                    overflow: "hidden",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                    background: "#fff",
                    position: "relative",
                    minHeight: 220,
                    display: "block"
                }}
                tabIndex={0}
            >
                <a
                    href={randomImage.image}
                    target="_blank"
                    rel="noopener noreferrer"
                    tabIndex={-1}
                    style={{ display: "block" }}
                >
                    <img
                        src={randomImage.image}
                        alt={randomImage.title || "Foto des Tages"}
                        loading="lazy"
                        decoding="async"
                        style={{
                            width: "100%",
                            height: 320,
                            objectFit: "cover",
                            display: "block"
                        }}
                    />
                </a>
                <figcaption
                    style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        padding: "16px 12px 8px 12px",
                        background: "linear-gradient(0deg,rgba(0,0,0,0.7) 70%,rgba(0,0,0,0.0) 100%)",
                        color: "#fff",
                        fontSize: 15,
                        minHeight: 48,
                        opacity: 0.95,
                        transition: "opacity 0.2s",
                        pointerEvents: "none"
                    }}
                    className="gallery-caption"
                >
                    <div style={{ fontWeight: 600, fontSize: 17 }}>
                        {randomImage.title || "Ohne Titel"}
                    </div>
                    {randomImage.photographer && (
                        <div style={{ fontSize: 13, opacity: 0.85 }}>
                            © {randomImage.photographer}
                        </div>
                    )}
                    {randomImage.description && (
                        <div style={{ fontSize: 13, marginTop: 2, opacity: 0.85 }}>
                            {randomImage.description.substring(0, 120)}
                        </div>
                    )}
                </figcaption>
                <style>{`
                    figure:focus-visible .gallery-caption,
                    figure:hover .gallery-caption {
                        opacity: 1 !important;
                        pointer-events: auto;
                    }
                    @media (hover: none) {
                        .gallery-caption {
                            opacity: 1 !important;
                        }
                    }
                `}</style>
            </figure>
        </div>
    );
};

export default PicoftheDay;
